import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class GameAssets {
    static backgroundsJpegSheetCount : number = 6;
    static mainSheetsCount : number = 20;
    static mainJpegSheetsCount : number = 3;
    static symbolSheetCount : number = 1;

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "MentalNumbersWinCountUp";
    static BITMAP_FONT_X_NUDGE_WIN_COUNT_UP = "xNudgeWinCountUp";
    static BITMAP_FONT_X_MULTIPLIER_WIN_COUNT_UP = "MultiplierWinCountUp";
    static BITMAP_FONT_X_HOLE_MULTIPLIER = "xholeNumbersMultiplier";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/MentalNumbersWinCountUp.fnt"),
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_X_NUDGE_WIN_COUNT_UP, "fonts/NumbersWinCountUp/xNudgeWinCountUp.fnt"),
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_X_MULTIPLIER_WIN_COUNT_UP, "fonts/multiplier/MultiplierWinCountUp.fnt"),
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_X_HOLE_MULTIPLIER, "fonts/xholeNumbersMultiplier.fnt")
                ],
                autoLoad: [AssetQualityLevel.HIGH]
            },
            {
                name: "backgrounds",
                assets: this.getTextureAssetsArray(GameAssets.backgroundsJpegSheetCount, "backgroundsJpeg")
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("reception", "spine/game_intro_page.json"),
                    new SpineAsset("fenesAnimation", "spine/fenes_animation.json"),
                    new SpineAsset("liftArrow", "spine/lift_arrow.json"),
                    new SpineAsset("liftFont", "spine/lift_font.json"),
                    new SpineAsset("winHighlight", "spine/win_toggle.json"),
                    new SpineAsset("L1", "spine/L1.json"),
                    new SpineAsset("L2", "spine/L2.json"),
                    new SpineAsset("L3", "spine/L3.json"),
                    new SpineAsset("L4", "spine/L4.json"),
                    new SpineAsset("L5", "spine/L5.json"),
                    new SpineAsset("M1", "spine/M1.json"),
                    new SpineAsset("M2", "spine/M2.json"),
                    new SpineAsset("M3", "spine/M3.json"),
                    new SpineAsset("M4", "spine/M4.json"),
                    new SpineAsset("M5", "spine/M5.json"),
                    new SpineAsset("W", "spine/W.json"),
                    new SpineAsset("D", "spine/D.json"),
                    new SpineAsset("D_A", "spine/dead_active.json"),
                    new SpineAsset("S1", "spine/S1.json"),
                    new SpineAsset("S2", "spine/S2.json"),
                    new SpineAsset("XSPLIT", "spine/Xsplit.json"),
                    new SpineAsset("XWAYS", "spine/xways.json"),
                    new SpineAsset("XNUDGE", "spine/xnudge.json"),
                    new SpineAsset("XHOLE", "spine/xhole.json"),
                    new SpineAsset("XMENTAL", "spine/xmental.json"),
                    new SpineAsset("xHoleBloodSuckEffect", "spine/xhole_blood_suck_effect.json"),
                    new SpineAsset("xSplitEffects", "spine/xsplit_cut_effect.json"),
                    new SpineAsset("xSplitWinOverlay", "spine/xsplit_win_overly_effect.json"),
                    new SpineAsset("xWaysEffects", "spine/xways_win_effect.json"),
                    new SpineAsset("xWaysWinOverlayEffects", "spine/xways_win_overly_effect.json"),
                    new SpineAsset("fireFrame", "spine/fire_frame.json"),
                    new SpineAsset("enhancer1", "spine/Enhancer_cell.json"),
                    new SpineAsset("enhancer2", "spine/Enhancer_cell_2.json"),
                    new SpineAsset("enhancer3", "spine/Enhancer_cell_3.json"),
                    new SpineAsset("enhancerEffects", "spine/Enhancer_cell_effects.json"),
                    new SpineAsset("mainGame", "spine/floor_0.json"),
                    new SpineAsset("freeSpin", "spine/floor_-2.json"),
                    new SpineAsset("coolFreeSpin", "spine/floor_-3.json"),
                    new SpineAsset("superFreeSpin", "spine/floor_-4.json"),
                    new SpineAsset("bgLevel1", "spine/15x.json"),
                    new SpineAsset("bgLevel2", "spine/25x.json"),
                    new SpineAsset("bgLevel3", "spine/50x.json"),
                    new SpineAsset("bgLevel4", "spine/100x.json"),
                    new SpineAsset("bgLevel5", "spine/1000x.json"),
                    new SpineAsset("fsIntroOutro", "spine/fs_intro_outro.json"),
                    new SpineAsset("cfsIntroOutro", "spine/cfs_intro_outro.json"),
                    new SpineAsset("sfsIntroOutro", "spine/sfs_intro_outro.json"),
                    new SpineAsset("glitchEffect", "spine/glitch_effect.json"),
                    new SpineAsset("xSpitBloodDripEffects", "spine/xsplit_win_overly_blood_drip_effect.json"),
                    new SpineAsset("scatterReelAnticipation", "spine/scatter_anticipation.json"),
                    new SpineAsset("xHoleLandEffect", "spine/xhole_land_effect.json"),
                    new SpineAsset("oldScreenEffect", "spine/mask_effect_for_BW_wincap.json"),
                    new SpineAsset("enhancerLine1", "spine/enhancer_line_4.json"),
                    new SpineAsset("enhancerLine3", "spine/enhancer_line_6.json"),
                    new SpineAsset("enhancerLine2", "spine/enhancer_line_8.json"),
                    new SpineAsset("GOD", "spine/xgod.json"),
                    new SpineAsset("wincap", "spine/99999x.json"),
                    new SpineAsset("preCountUp0", "spine/pre_countup.json"),
                    new SpineAsset("preCountUp1", "spine/pre_countup_1.json"),
                    new SpineAsset("preCountUp2", "spine/pre_countup_2.json"),
                    new SpineAsset("TS1", "spine/T1.json"),
                    new SpineAsset("idleFlicker", "spine/flicker_light.json"),
                    new SpineAsset("xGodBigSym", "spine/xgod_big_symbol.json"),
                    new SpineAsset("xMental", "spine/xmental.json"),
                    new SpineAsset("xMentalBigSymbolEffect", "spine/xmental_bigSymbol_effect.json"),
                    new SpineAsset("xMentalAnticipation", "spine/xmental_anticipation.json"),
                ]
            },
            {
                name: "main",
                assets: this.getTextureAssetsArray(GameAssets.mainSheetsCount, "main"),
            },
            {
                name: "mainJpeg",
                assets: this.getTextureAssetsArray(GameAssets.mainJpegSheetsCount, "mainJpeg"),
            },
            {
                name: "symbolsHighQuality",
                assets: this.getTextureAssetsArray(GameAssets.symbolSheetCount, "symbolsHighQuality"),
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH]
            }
        ]
    };

    private static getTextureAssetsArray(count: number, preFix: string): TextureAsset[] {
        const arr: TextureAsset[] = [];
        for (let counter: number = 0; counter <= count; counter++) {
            const str: string = preFix + counter;
            const url: string = "sheets/" + preFix + "/" + str + ".json"
            arr.push(new TextureAsset(str, url));
        }
        return arr;
    }

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }
}
